import restful from '@/utils/restful';
import * as names from '@/store/names';
import * as get from '@/store/store';

const state = {
    instructional_moments: [],
    instructional_moments_url: '/teaching/instructional-moment'
}

const getters = {
    [names.INSTRUCTIONAL_MOMENTS]: state => {
        if (!get.store.state.user) return [];
        return state.instructional_moments
            .filter((x) => x.school == get.store.state.user.school)
            .sort(function (a, b) {
                if (a.order > b.order) return 1;
                if (a.order < b.order) return -1;
                return 0;
            });
    },
    [names.INSTRUCTIONAL_MOMENT]: (state,) => id => {
        return state.instructional_moments.find(x => x.id == id);
    },
}

const mutations = {
    [names.MUTATE_INSTRUCTIONAL_MOMENTS]: (state, instructional_moments) => {
        instructional_moments.forEach(element => {
            let index = state.instructional_moments.findIndex(x => x.id == element.id);
            if (index != -1) state.instructional_moments.splice(index, 1, element);
            else state.instructional_moments.push(element);
        });
        state.instructional_moments.sort(function (a, b) {
            return ((a.order < b.order) ? -1 : ((a.order > b.order) ? 1 : 0));
        });
    },
    [names.MUTATE_INSTRUCTIONAL_MOMENT]: (state, instructional_moment) => {
        let index = state.instructional_moments.findIndex(x => x.id == instructional_moment.id);
        if (index != -1) state.instructional_moments.splice(index, 1, instructional_moment);
        else state.instructional_moments.push(instructional_moment);
        state.instructional_moments.sort(function (a, b) {
            return ((a.order < b.order) ? -1 : ((a.order > b.order) ? 1 : 0));
        });
    },
    [names.MUTATE_DELETE_INSTRUCTIONAL_MOMENT]: (state, instructional_moment_id) => {
        let index = state.instructional_moments.findIndex(x => x.id == instructional_moment_id);
        if (index != -1) state.instructional_moments.splice(index, 1);
    },
}

const actions = {
    /**
     * payload opcional: { method_id, force }
     * Nota: los momentos también viajan anidados en `InstructionalMethod.moments`,
     * por lo que la vista normalmente no necesita este fetch.
     */
    [names.FETCH_INSTRUCTIONAL_MOMENTS]: ({
        commit,
        state,
    }, payload = {}) => {
        const { method_id = null, force = false } = payload;
        return new Promise((resolve, reject) => {
            if (!force && state.instructional_moments.length > 0) {
                resolve(state.instructional_moments);
                return;
            }
            let query = '';
            if (method_id != null) query = `?method=${method_id}`;
            restful.GetAll(`${state.instructional_moments_url}/${query}`)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_MOMENTS, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.POST_INSTRUCTIONAL_MOMENT]: ({
        commit,
        state
    }, instructional_moment) => {
        return new Promise((resolve, reject) => {
            restful.Post(`${state.instructional_moments_url}/`, instructional_moment)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_MOMENT, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.UPDATE_INSTRUCTIONAL_MOMENT]: ({
        commit,
        state
    }, instructional_moment) => {
        return new Promise((resolve, reject) => {
            restful.Put(`${state.instructional_moments_url}/${instructional_moment.id}/`, instructional_moment)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_MOMENT, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    // payload: { instructional_moment_id, item }
    [names.PATCH_INSTRUCTIONAL_MOMENT]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve, reject) => {
            restful.Patch(`${state.instructional_moments_url}/${payload.instructional_moment_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_MOMENT, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.DELETE_INSTRUCTIONAL_MOMENT]: ({
        commit,
        state
    }, instructional_moment_id) => {
        return new Promise((resolve, reject) => {
            restful.Delete(`${state.instructional_moments_url}/${instructional_moment_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_INSTRUCTIONAL_MOMENT, instructional_moment_id);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
